import React, { memo } from 'react'
import { DialogContent, DialogActions, Box } from '@mui/material'

import CustomButton from '../buttons/CustomButton'
import { QB_ACTION_BUTTON, QB_ACTION_SUBMIT } from '../../../constants/input'
import CustomForm from '../forms/customForm/CustomForm'

const CustomDialogContent = ({
  body,
  onClose,
  onSubmit,
  t,
  cancelProps,
  submitProps,
  additionalActions,
  customCss,
  isForm,
  actionStyles
}) => {
  const submitStyleProps = {
    variant: 'contained',
    fullWidth: false,
    ...submitProps
  }

  const dialogContent = (
    <>
      {body && (
        <DialogContent sx={{ pt: 2, pb: 2, pr: 4, pl: 4, ...customCss }}>
          {body}
        </DialogContent>
      )}
      <DialogActions sx={{ p: 4, ...actionStyles }}>
        {onClose && (
          <CustomButton
            label={t('common.close')}
            onClick={onClose}
            color='inherit'
            fullWidth={false}
            variant=''
            {...cancelProps}
          />
        )}
        <Box sx={{ flex: '1 1 auto' }} />
        {submitProps && (
          <>
            {additionalActions}
            {isForm ? (
              <CustomButton type={QB_ACTION_SUBMIT} {...submitStyleProps} />
            ) : (
              <CustomButton
                type={QB_ACTION_BUTTON}
                onClick={onSubmit}
                {...submitStyleProps}
              />
            )}
          </>
        )}
      </DialogActions>
    </>
  )
  return isForm ? (
    <CustomForm onFormSubmit={onSubmit}>{dialogContent}</CustomForm>
  ) : (
    dialogContent
  )
}

export default memo(CustomDialogContent)
